import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delegate-invitation-sent',
  templateUrl: './delegate-invitation-sent.component.html',
  styleUrls: ['./delegate-invitation-sent.component.scss']
})
export class DelegateInvitationSentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
